import { ModuleWithProviders, NgModule } from '@angular/core';
import { BUUPASS_AUTH_CONFIG } from './tokens/auth-config.token';
import { BuupassAuthConfig } from './types/auth-config';

@NgModule()
export class BuupassAuthModule {
  static forRoot(config: BuupassAuthConfig): ModuleWithProviders<BuupassAuthModule> {
    return {
      ngModule: BuupassAuthModule,
      providers: [
        {
          provide: BUUPASS_AUTH_CONFIG,
          useValue: config
        }
      ]
    };
  }
}
